//Generated File 
export default class AppointmentsRole{
	static readonly Admin = `Admin`;
	static readonly None = `None`;
	static readonly Supervisor = `Supervisor`;
	static readonly Technician = `Technician`;
}
